import React, {
  useState, useRef, forwardRef, useImperativeHandle,
} from 'react';
import Button from './Button';
import ImagePreviewWithOverlay from './ImagePreviewWithOverlay';

interface CameraAccessProps {
  onCapture: (file: File) => void;
  className?: string;
  buttonLabel?: string;
}

const CameraAccessOverlay = forwardRef((
  {
    onCapture,
    className, buttonLabel = 'Add Picture',
  }: CameraAccessProps, ref,
) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [previewURL, setPreviewURL] = useState<string | null>(null);

  useImperativeHandle(ref, () => ({
    openCamera: () => {
      fileInputRef.current?.click();
    },
  }));

  const handleCapture = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setImageFile(file);
      setPreviewURL(URL.createObjectURL(file));
    }
  };

  const handleConfirm = (croppedBlob: Blob) => {
    const file = new File([croppedBlob], imageFile?.name || 'cropped.jpg', {
      type: imageFile?.type || 'image/jpeg',
    });
    onCapture(file);
    setImageFile(null);
    setPreviewURL(null);
  };

  const handleRetake = () => {
    setImageFile(null);
    setPreviewURL(null);
  };

  return (
    <>
      {!previewURL ? (
        <>
          <Button
            onClick={
            () => fileInputRef.current?.click()
}
            variant="primary"
            className={className}
          >
            {buttonLabel}
          </Button>
          <input
            type="file"
            accept="image/*"
            capture="environment"
            onChange={handleCapture}
            ref={fileInputRef}
            style={{ display: 'none' }}
          />
        </>
      ) : (
        <ImagePreviewWithOverlay
          imageURL={previewURL}
          onConfirm={handleConfirm}
          onRetake={handleRetake}
        />
      )}
    </>
  );
});

export default CameraAccessOverlay;
